import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  createScaffolderFormDecorator,
  FormDecoratorBlueprint,
} from '@backstage/plugin-scaffolder-react/alpha';
import { oidcAuthApiRef } from 'plugin-app-module-adp-oidc-session-logout';

const argoDexTokenDecorator = createScaffolderFormDecorator({
  id: 'adp:argocd-dex-token',
  deps: {
    oidcAuthApi: oidcAuthApiRef,
  },
  async decorator({ setSecrets }, { oidcAuthApi }) {
    const token = await oidcAuthApi.getIdToken();

    if (!token) {
      throw new Error('Unable to obtain Dex ID token for ArgoCD');
    }

    setSecrets(currentSecrets => ({
      ...currentSecrets,
      ARGOCD_DEX_TOKEN: token,
    }));
  },
});

export const scaffolderArgoDexTokenModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormDecoratorBlueprint.make({
      name: 'adp-argocd-dex-token',
      params: {
        decorator: argoDexTokenDecorator,
      },
    }),
  ],
});
